const ticker = document.querySelector('.announcement-bar-section');
const menuDrawer = document.querySelector('.menu-drawer');
const menuIcon = document.querySelector('.menu-drawer-container .header__icon--menu');
const logo = document.querySelector('.header__heading') || document.querySelector('.header__heading-link');

/**
 * Calculate menu drawer height checking ticker height
 */
function setMenuDrawerHeight() {
  const tickerHeight = ticker.offsetHeight;
  menuDrawer.style.height = `${window.innerHeight - tickerHeight}px`;
}

/**
 * Set logo position while menu is open or closed
 */
function setLogoPosition() {
  const isMenuOpen = document.querySelector('.section-header.menu-open');
  if (isMenuOpen) {
    if (isMobile()) {
      logo.style.translate = 0;
    } else {
      let currentTranslate = 0;
      if (logo.style.translate) {
        currentTranslate = logo.style.translate ? parseFloat(logo.style.translate.replace('px', '')) : 0;
      }
      const currentPosition = logo.getBoundingClientRect().left + (currentTranslate * -1);
      logo.style.translate = `${(currentPosition * -1)}px`;
    }
  } else {
    logo.style.translate = 0;
  }
}

if (menuIcon && menuDrawer && logo) {
  menuIcon.addEventListener('click', () => {
    setLogoPosition();
  });
}

if (ticker && menuDrawer) {
  setMenuDrawerHeight();
}

if (menuDrawer && (ticker || logo)) {
  window.addEventListener(
    'resize',
    debounce(() => {
      if (ticker) {
        setMenuDrawerHeight();
      }
      if (logo) {
        setLogoPosition();
      }
    }),
  );
}
